import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import InputField from "./InputField";
import { Colors } from "../../config";
import Checkbox from "./Checkbox";
import Button from "./Button";

const PreferredAirlines = ({
  airlines,
  onCheck,
  onClassSelect,
  helperText,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const [filteredAirlines, setFilteredAirlines] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [value, setValue] = useState("");
  const [selectedClass, setSelectClass] = useState("Economy");
  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowOptions(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  useEffect(() => {
    setFilteredAirlines(airlines);
  }, [airlines]);

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const handleShow = (e) => {
    e.preventDefault();
    setShowOptions(true);
  };

  const handleClassSelect = (_class) => {
    setSelectClass(_class);
    onClassSelect(_class);
  };

  const handleChange = (e) => {
    setValue(e.target.value);
    let filtered = airlines?.filter((item) =>
      item.label.toUpperCase().includes(e.target.value.toUpperCase())
    );
    setFilteredAirlines(filtered);
  };

  let selectedAirlines = airlines?.filter((item) => item.selected);
  return (
    <PreferredAirlinesWrapper ref={wrapperRef}>
      <InputField
        label="Preferred Airlines"
        value={
          showOptions
            ? value
            : `Selected ${selectedAirlines?.length || 0} Airlines`
        }
        isRounded
        onFocus={(e) => handleShow(e)}
        helperText={helperText}
        onChange={handleChange}
        placeholder={'Search by airlines'}
      />
      {showOptions && (
        <Options>
          <ListOptions>
            <SelectMax>Choose Up to 5 Airlines!</SelectMax>
            <ListHeader>Preferred Airlines</ListHeader>
            {showMore ? (
              <SelectList>
                {filteredAirlines.map((item, index) => (
                  <Checkbox
                    size={"1rem"}
                    fontWeight={600}
                    label={item.label}
                    fontSize={"0.875rem"}
                    setIsChecked={(val) => onCheck(val, item.label)}
                    isChecked={item.selected}
                  />
                ))}
              </SelectList>
            ) : (
              <SelectList>
                {filteredAirlines?.slice(0, 5).map((item, index) => (
                  <Checkbox
                    size={"1rem"}
                    fontWeight={600}
                    label={item.label}
                    fontSize={"0.875rem"}
                    setIsChecked={(val) => onCheck(val, item.label)}
                    isChecked={item.selected}
                  />
                ))}
              </SelectList>
            )}
          </ListOptions>
          <PlaneListLink onClick={() => setShowMore(!showMore)}>
            {filteredAirlines?.length > 5 && (
              <>{showMore ? <a>Show Less</a> : <a>Show More</a>}</>
            )}
          </PlaneListLink>
          <Button
            color={Colors.red}
            label={"Done"}
            onClick={() => setShowOptions(false)}
          />
        </Options>
      )}
    </PreferredAirlinesWrapper>
  );
};

const PlaneListLink = styled.p`
  color: ${Colors.red};
  text-decoration: underline;
  text-align: center;
  font-size: 0.8rem;
`;
const ListOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  // margin-bottom: 1rem;
  height: 150px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.875rem;
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar-thumb {
    height: 3.625rem;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 0.625rem;
    background-color: ${Colors.brandOne};
  }
`;
const ListHeader = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  padding: 9px 0;
`;
const SelectList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
const ClassCard = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid
    ${(props) => (props.selected ? Colors.pomegranate : Colors.alto)};
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  background: ${(props) =>
    props.selected ? Colors.pomegranateOpacity10 : "transparent"};
`;
const ClassWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
`;
const Options = styled.div`
  position: absolute;
  width: 90%;
  padding: 1rem;
  border-radius: 1rem;
  background: ${Colors.white};
  top: 5.5rem;
  border: 1px solid ${Colors.sharkApproxOpacity40};
  display: flex;
  flex-direction: column;
  z-index: 9999;
`;
const PreferredAirlinesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;
const SelectMax = styled.div`
  font-weight: 400;
  font-size: 0.875rem;
  color: ${Colors.brandTwo};
`;
export default PreferredAirlines;
